<template>
    <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
            <a-form :model="queryParam" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" name="basic">
                <a-row justify="space-between">
                    <a-col :span="4">
                        <a-form-item label="试卷名">
                            <a-input v-model="queryParam.paperName" placeholder="请输入试卷名" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="4">
                        <a-form-item label="试卷库">
                            <j-dict-select-tag type="list" v-model="queryParam.paperType" dictCode="paper_type"
                                placeholder="请选择试卷库" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="4">
                        <a-form-item label="试卷状态">
                            <j-dict-select-tag placeholder="请选择试卷状态" v-model="queryParam.paperStatus"
                                dictCode="paper_status" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="4">
                        <a-form-item label="试卷ID">
                            <a-input v-model="queryParam.id" placeholder="请输入试卷ID" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="">
                            <a-button type="primary" @click="searchQuery" icon="search" style="margin-left: 8px">查询</a-button>
                            <a-button type="primary" @click="searchReset" icon="reload"
                                style="margin-left: 8px">重置</a-button>
                            <a-button type="primary" style="margin-left: 8px;" icon="plus" @click="handleAdd">
                                新增试卷
                            </a-button>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>

        </div>
        <!-- table区域-begin -->
        <div>
            <a-table ref="table" size="middle" bordered rowKey="id" class="j-table-force-nowrap" :scroll="{ x: true }"
                :columns="columns" :dataSource="dataSource" :pagination="ipagination" :loading="loading"
                :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" @change="handleTableChange">
                <template slot="htmlSlot" slot-scope="text">
                    <div v-html="text"></div>
                </template>
                <template slot="imgSlot" slot-scope="text">
                    <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
                    <img v-else :src="getImgView(text)" :preview="text" height="25px" alt=""
                        style="max-width: 80px; font-size: 12px; font-style: italic" />
                </template>
                <template slot="fileSlot" slot-scope="text">
                    <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
                    <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
                        下载
                    </a-button>
                </template>

                <span slot="action" slot-scope="text, record">
                    <a @click="handleEdit(record)">编辑</a>
                    <a-divider type="vertical" />
                    <a @click="handleComposing(record)">组卷</a>
                    <a-divider type="vertical" />

                    <a-dropdown>
                        <a class="ant-dropdown-link">导出试卷 <a-icon type="down" /></a>
                        <a-menu slot="overlay">
                            <a-menu-item>
                                <a @click="examport(record.id, record.paperName, 'B')">普通导出</a>
                            </a-menu-item>
                            <a-menu-item>
                                <a @click="examport(record.id, record.paperName, 'A')">带答案导出</a>
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                    <a-divider type="vertical" />
                    <a-dropdown>
                        <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                        <a-menu slot="overlay">
                            <a-menu-item>
                                <a :href="'/paper?paperId=' + record.id" target="_blank">试卷报告</a>
                            </a-menu-item>
                            <a-menu-item>
                                <a-popconfirm title="确定复制该试卷吗?" @confirm="() => handleCopy(record.id)">
                                    <a>复制</a>
                                </a-popconfirm>
                            </a-menu-item>
                            <a-menu-item>
                                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                                    <a>删除</a>
                                </a-popconfirm>
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown>
                </span>
            </a-table>
        </div>
        <teaching-paper-modal ref="modalForm" @ok="modalFormOk" />
    </a-card>
</template>
  
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import TeachingPaperModal from './components/testPaper/TeachingPaperModal'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
import { getAction, downFile } from '@/api/manage'
import '@/assets/less/TableExpand.less'

export default {
    name: 'TeachingPaperList',
    mixins: [JeecgListMixin],
    components: {
        JDictSelectTag,
        TeachingPaperModal,
    },
    data() {
        return {
            description: '试卷管理页面',
            // 表头
            columns: [
                {
                    title: '#',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 60,
                    align: 'center',
                    customRender: function (t, r, index) {
                        return parseInt(index) + 1
                    },
                },
                {
                    title: '试卷ID',
                    align: 'center',
                    width: 120,
                    dataIndex: 'id',
                },
                {
                    title: '试卷名',
                    align: 'center',
                    dataIndex: 'paperName',
                },
                {
                    title: '试卷库',
                    align: 'center',
                    dataIndex: 'paperType_dictText',
                },
                {
                    title: '试卷类型',
                    align: 'center',
                    dataIndex: 'isSimulation',
                    customRender(v) {
                        switch(v){
                            case 0: return '正式卷'
                            case 1: return '模拟卷'
                            case 2: return '作业卷'
                            case 3: return '练习卷'
                            default: return v
                        }
                    }
                },
                // {
                //     title: '组卷方式',
                //     align: 'center',
                //     dataIndex: 'compositionMethod',
                //     customRender(v) {
                //         if (v == 0) { return '固定题目' }
                //         else if (v == 1) { return '抽题' }
                //     }
                // },
                {
                    title: '难度',
                    align: 'center',
                    dataIndex: 'paperDifficulty_dictText'
                },
                {
                    title: '限时',
                    align: 'center',
                    dataIndex: 'timeLimit',
                    customRender(v) {
                        return v == 0 ? "不限" : v
                    }
                },
                // {
                //   title: '答题限次',
                //   align: 'center',
                //   dataIndex: 'submitTimesLimit',
                //   customRender(v){
                //     return v==-1?"不限":v
                //   }
                // },
                // {
                //   title: '跳出次数限次',
                //   align: 'center',
                //   dataIndex: 'jumpOutLimit',
                //   customRender(v){
                //     return v==-1?"不限":v
                //   }
                // },
                {
                    title: '总分',
                    align: 'center',
                    dataIndex: 'totalScore',
                },
                {
                    title: '题目数量',
                    align: 'center',
                    dataIndex: 'questionCount',
                },
                {
                    title: '错题本',
                    align: 'center',
                    dataIndex: 'revisionBook',
                    customRender(v) {
                        return v == 1 ? '开放' : '关闭'
                    }
                },
                {
                    title: '试卷状态',
                    align: 'center',
                    dataIndex: 'paperStatus_dictText',
                },

                // {
                //   title: '试卷介绍',
                //   align: 'center',
                //   dataIndex: 'paperDesc',
                //   scopedSlots: {customRender: 'htmlSlot'}
                // },
                {
                    title: '试卷关键词',
                    align: 'center',
                    dataIndex: 'paperKeywords',
                },
                {
                    title: '关联课程',
                    align: 'center',
                    dataIndex: 'courseId_dictText',
                },
                {
                    title: '创建时间',
                    align: "center",
                    dataIndex: 'createTime',
                    sorter: true
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    align: 'center',
                    fixed: 'right',
                    width: 147,
                    scopedSlots: { customRender: 'action' },
                },
            ],
            url: {
                list: '/teaching/teachingPaper/list',
                delete: '/teaching/teachingPaper/delete',
                deleteBatch: '/teaching/teachingPaper/deleteBatch',
                exportXlsUrl: '/teaching/teachingPaper/exportXls',
                importExcelUrl: 'teaching/teachingPaper/importExcel',
            },
            dictOptions: {},
        }
    },
    created() { },
    computed: {
        importExcelUrl: function () {
            return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
        },
    },
    methods: {
        initDictConfig() { },
        toPaper(id) {
            let route = this.$router.resolve({
                path: 'preview',
                query: {
                    id: id,
                },
            });
            window.open(route.href, '_blank')
        },
        handleComposing(record) {
            let route = this.$router.resolve({
                path: '/composing',
                query: {
                    id: record.id,
                },
            });
            window.open(route.href, '_blank')
        },
        handleCopy(paperId) {
            getAction("/teaching/teachingPaper/copy", { paperId }).then(res => {
                this.$message.info(res.message)
                this.searchQuery()
            })
        },
        examport(paperId, name, type) {
            var fileName = name;
            if (!fileName || typeof fileName != "string") {
                fileName = "导出文件"
            }
            downFile('/teaching/teachingPaper/getPaperExportWordFile', { "paperId": paperId, "type": type }).then((data) => {
                if (!data) {
                    this.$message.warning("文件下载失败")
                    return
                }
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-word' }), fileName + '.doc')
                } else {
                    let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-word' }))
                    let link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = url
                    link.setAttribute('download', fileName + '.doc')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                }
            })
        },
        //打开字典编辑器
        handleEditDict(dictCode) {
            this.$refs.dictItemList.open(dictCode)
        },
        //打开分类字典编辑器
        handleEditCateDict(dictCode) {
            this.$refs.categoryDrawer.open(dictCode)
        },
        handleGetLink(id) {
            return window.location.protocol + "//" + window.location.host + "/exam/examine?id=" + id
        },
        handleGetOutLink(id) {
            return window.location.protocol + "//" + window.location.hostname + "/examine?id=" + id
        }
    },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>